import React from "react";

import colors from "core/colors";
import BaseIcon from "./BaseIcon";

const Search = ({
    size = null,
    ariaLabel = null,
    ariaHidden = true,
    fillColor,
    fillColorRule,
    className
}) => {
    return (
        <BaseIcon
            size={size}
            fillColor={fillColor}
            fillColorRule={fillColorRule}
            className={className}
            aria-hidden={ariaHidden ? "true" : "false"}
            aria-label={ariaLabel}
        >
            <path
                fill={colors.secondary.orca}
                d="M17.121 15l5.598 5.597a.5.5 0 010 .707l-1.415 1.415a.5.5 0 01-.707 0L15 17.12 17.121 15z"
                key="key-0"
            />
            <path
                fill={colors.secondary.orca}
                fillRule="evenodd"
                d="M10.5 19a8.5 8.5 0 100-17 8.5 8.5 0 000 17zm0-2.75a5.75 5.75 0 100-11.5 5.75 5.75 0 000 11.5z"
                clipRule="evenodd"
                key="key-1"
            />
        </BaseIcon>
    );
};

export default Search;
